import { Box, Container, Typography } from "@mui/material";

export const LandingCenteredTitleWithText = ({ title, text, children }) => {
  return (
    <>
      <Container maxWidth="lg">
        <Box component={Typography} sx={{ textAlign: "center" }} variant="h2">
          {title}
        </Box>
      </Container>
      <Container
        sx={{
          py: 2.5,
          my: 2,
        }}
      >
        {text && (
          <Box
            sx={{
              margin: "auto",
              textAlign: "center",
              px: 4,
              maxWidth: {
                xs: "100%",
                sm: "90%",
                md: "80%",
                lg: "70%",
              },
            }}
          >
            <Typography variant="bodyLg">{text}</Typography>
          </Box>
        )}
        {children && <Box>{children}</Box>}
      </Container>
    </>
  );
};
